module.exports = __webpack_public_path__ + "img/user_placeholder.d67e6fea.svg";